import React from 'react';
import styled, {css} from "styled-components";
import loaderAnimation from "../images/ajax-loader.gif";


const Wrapper = styled.div`
    text-align: center;
    margin-top: 146px;

    ${props => props.theme.mediaQueries.medium}{
        margin-top: 206px;
    };
`

const Img = styled.img`
    height: 50px;
    width: 50px;
`

const Description = styled.p`
    font-size: 1.83rem;
    color: #4f525d;
    margin-top: 16px;

    ${props => props.theme.mediaQueries.medium}{
        font-size: 1.7rem;
        margin-top: 26px;
    };
`

const Loader = () => {
    return (
        <Wrapper>
            <Img src={loaderAnimation} title="Loading" />
            <Description>Vent et øjeblik</Description>
        </Wrapper>
    )
}

export default Loader;